import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { PortalRoutesWrapper, RequireUserType } from "@/app/components/auth";
import { PORTAL_USER_TYPE } from "@/app/models";
import { UpgradeSubscription } from "@/features/subscriptions/screens";
import { ChangeSubscription, Overview } from "../screens";
import { BILLING_ROUTE } from "./constants";

export const getBillingRoute = (): RouteObject => ({
  path: BILLING_ROUTE.BASE,
  element: <PortalRoutesWrapper />,

  children: [
    { index: true, element: <Overview /> },

    {
      path: BILLING_ROUTE.CHANGE_SUBSCRIPTION,
      element: (
        <RequireUserType allowedUserTypes={[PORTAL_USER_TYPE.PATIENT]}>
          <ChangeSubscription />
        </RequireUserType>
      ),
    },

    {
      path: BILLING_ROUTE.UPGRADE_SUBSCRIPTION,
      element: (
        <RequireUserType allowedUserTypes={[PORTAL_USER_TYPE.PATIENT]}>
          <UpgradeSubscription />
        </RequireUserType>
      ),
    },

    { path: "*", element: <Navigate replace to={BILLING_ROUTE.BASE} /> },
  ],
});
